fragment SmsMembershipStatsFragment on AudienceSmsMembershipStats {
    totalCount {
        value
    }
    subscribedCount
    optedOutCount
    missingPhoneNumberCount
    duplicatePhoneNumberCount
    undeliverableCount
}
